import React from 'react'
import styles from './Branches.module.css'; 
import BranchCard from "./BranchCard";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import {useSelector} from 'react-redux';
import image from '../../Images/1.png'
import Spinner from 'react-bootstrap/Spinner';




function Branches({branches, loading}) {

  console.log("loading",loading)
  const { t, i18n } = useTranslation();
  const safeBranches = Array.isArray(branches) ? branches : [];

  return (
    <>
     {loading ? <div style={{display:"flex", justifyContent:"center"}}>

<Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
</div>:
    <div>
      <div>
      <div className={styles.chooseBranchLabel} >{t("choose_nearest_branch")}</div>
      </div>
{ safeBranches &&
    <div style={{ display: "flex", flexWrap: "wrap",direction:"rtl", justifyContent: "space-between", maxWidth:"900px", margin:"auto" }}>
    {safeBranches?.map((branch) => (
      <BranchCard
        key={branch.brn_num}
        branch={branch}
        cityName={branch.brn_citynam}
        branchName={branch.brn_nam}
        photo={`https://reservation.ladycaresa.com/public/uploads${branch.brn_img}`}
        />
    ))}
  </div>}
    <div>
      {/* <Footer /> */}
    </div>
    </div>}
    </>
  )
}
export default Branches;
